import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import {Link} from 'gatsby';

function Banner(props) {
    return (
        <div className="services_location_banner">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
                        <div className="banenr_content">
                            <div className="example" data-text="Austin">
                                <h1>Growth-Centric Software Development Company in <span>Austin</span></h1>
                            </div>
                            <p className="main_para">Partner with TekRevol, an experienced software development company in Austin providing next-gen software solutions to businesses operating in this region. Having expertise in diverse aspects of custom software development, we facilitate our clients with each requirement & deliver a cutting edge digital solution.</p>
                            <Link to="/contact"
                            className="border_btn dark_btn" aria-label="TekRevol Contact"> Let’s Get Started</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
                        <Bannerfrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;